module.exports = {
  REPATRIATIONS_TRANSACTIONS_DELETE_REQUEST: 'REPATRIATIONS_TRANSACTIONS_DELETE_REQUEST',
  REPATRIATIONS_TRANSACTIONS_DELETE_SUCCESS: 'REPATRIATIONS_TRANSACTIONS_DELETE_SUCCESS',
  REPATRIATIONS_TRANSACTIONS_DELETE_FAILURE: 'REPATRIATIONS_TRANSACTIONS_DELETE_FAILURE',
};
